import { render, staticRenderFns } from "./InfosBlock.vue?vue&type=template&id=4cc947ac"
import script from "./infosBlock.ts?vue&type=script&lang=js&external"
export * from "./infosBlock.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports